import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useCreateBudgetPlan = (onSuccess) => {
  const queryClient = useQueryClient();
  const mutationFn = useApiRequest({
    url: "/users/me/budget-plan",
    method: HttpMethod.Post,
  });

  return useMutation({
    mutationKey: ["create-user-budget-plan"],
    mutationFn: (data) => mutationFn({ data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["budget-plan"] });

      onSuccess?.();
    },
  });
};
